import { AppleNewArrivalList } from './AppleStore';
import { useNavigate } from 'react-router-dom';

const AppleNewArrivals = () => {
  const navigate = useNavigate();

  return (
    <div className="new-arrivals">
      <h2 className="apple-explore">
        New arrivals are here — <strong>Explore now!</strong>
      </h2>
      <div className="explore-product-gallery">
        {AppleNewArrivalList.map((product) => (
          <div
            key={product.id}
            className="explore-product-card"
            style={{ backgroundImage: `url(${product.image})` }}
            onClick={() => navigate(product.path)}
          >
            {/* <p>{product.name}</p> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppleNewArrivals;
